import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { PageLayout } from "@cvx/nextpage";
import { IWorkflowRequest } from "src/app/models/requests/WorkflowRequest";
import { CalAngularService, ICvxClaimsPrincipal } from "@cvx/cal-angular";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { SelectionModel } from "@angular/cdk/collections";
import { IGenericApiResponse } from "src/app/models/common/GenericApiResponse";
import { DirectoryDomain } from "src/app/models/directory/enums/DirectoryDomain.enum";
import { DialogAppSearchChevronComponent } from "../dialog-app-search-chevron/dialog-app-search-chevron.component";
import { IDialogAppSearchChevronData } from "src/app/models/idm/applications/IDialogAppSearchChevronData";
import { IIdmApplication, IdmApplication } from "src/app/models/idm/applications/IdmApplication";
import { MatDialog } from "@angular/material/dialog";
import { ToStringHelper } from "src/app/helpers/ToStringHelper";
import { IGenericApiResponseWithWorkflowRequest } from "src/app/models/common/GenericApiResponseWithWorkflowRequest";
import { GraphApplication } from "src/app/models/graph/applications/GraphApplication";
import { GraphApplicationService } from "src/app/services/graph/GraphApplication.service";
import { GraphApplicationUpdate, GraphApplicationUpdateForm } from "src/app/models/graph/applications/GraphApplicationUpdate";
import { GraphApplicationsUpdateRequest } from "src/app/models/graph/applications/GraphApplicationsUpdateRequest";
import { IdmClientSecretAutoRotationConfig } from "src/app/models/graph/applications/IdmClientSecretAutoRotationConfig";
import { DialogCreateClientSecretAutoRotationConfigFormComponent } from "../dialog-create-client-secret-auto-rotation-config-form/dialog-create-client-secret-auto-rotation-config-form.component";
import { IDialogCreateClientSecretAutoRotationConfigData } from "src/app/models/idm/IDialogCreateClientSecretAutoRotationConfigData";
import { IGraphAppExposedPermissions } from "src/app/models/graph/applications/GraphAppExposedPermissions";
import { environment } from "src/environments/environment";

@Component({
  selector: 'update-application-form',
  templateUrl: './update-application-form.component.html',
  styleUrl: './update-application-form.component.css'
})
export class UpdateApplicationFormComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    this.applicationsDataSource.paginator = value;
  }
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    this.applicationsDataSource.sort = value;
  }

  @Input() onlyApplicationsToUpdate: GraphApplication[] | undefined = undefined;
  @Input() requestSubmittedEndRoute: string = '/applications/update';
  @Output() updatedApplications = new EventEmitter<GraphApplication[]>();
  chevronApp: IIdmApplication | null = null;

  domain = DirectoryDomain.Chevron;
  isClientSecretConfigCapabilitiesEnabled: boolean = environment.isClientSecretConfigCapabilitiesEnabled;
  updatingPassedApplications: boolean = false;
  applicationUpdateTitle: string = 'selected applications to update';
  gettingapplications: boolean = true;
  isSubmitting: boolean = false;
  selection: SelectionModel<GraphApplication> = new SelectionModel<GraphApplication>(true, []);;
  applicationUpdatesDataSource = new MatTableDataSource<GraphApplicationUpdateForm>([]);
  public readonly removedConfigState = 'removed';
  public readonly addedConfigState = 'added';
  public readonly existingConfigState = 'existing';

  private commonColumns: string[] = ['displayName', 'appId', 'serviceId'];
  applicationsDisplayedColumns: string[] = ['select', ...this.commonColumns];
  applicationsFormDisplayedColumns: string[] = [...this.commonColumns];
  applicationsFormDataColumns: string[] = [...this.applicationsFormDisplayedColumns, 'del'];
  PageLayout = PageLayout;
  submitErrorMessage = { message: '', errors: [] };
  submittedRequests: IWorkflowRequest[] = [];

  currentUserProfile: ICvxClaimsPrincipal;
  applicationsDataSource = new MatTableDataSource<GraphApplication>([]);

  constructor(private graphApplicationService: GraphApplicationService, private authService: CalAngularService, private dialog: MatDialog) {
  }

  async ngOnInit(): Promise<void> {
    if (this.onlyApplicationsToUpdate != undefined) {
      this.applicationUpdateTitle = 'update required to proceed';
      this.applicationsDataSource.data = this.onlyApplicationsToUpdate;
      this.applicationsDataSource.paginator = this.paginator
      this.applicationsDataSource.sort = this.sort
      this.onlyApplicationsToUpdate.forEach(a => this.select(a));
      this.gettingapplications = false;
      this.updatingPassedApplications = true;
    }
    else {
      this.graphApplicationService.GetOwned().subscribe({
        next: (x: IGenericApiResponse<GraphApplication[]>) => {
          this.applicationsDataSource.data = x.data;
          this.applicationsDataSource.paginator = this.paginator
          this.applicationsDataSource.sort = this.sort
        },
        error: (e) => {
          console.error(e);
          this.gettingapplications = false;
        },
        complete: () => this.gettingapplications = false
      });
    }


  }

  clearChevronApp() {
    this.chevronApp = null;
  }

  deleteRow(row: GraphApplicationUpdate) {
    this.applicationUpdatesDataSource.data = [...this.applicationUpdatesDataSource.data.filter(g => g.id != row.id)];
    this.selection.deselect(row);
  }
  addapplicationUpdate(row: GraphApplication) {
    let applicationUpdate = row as GraphApplicationUpdateForm;

    applicationUpdate.applicationId = row.id;
    applicationUpdate.adminAppRolesToAdd = [];
    applicationUpdate.adminAppRolesToRemove = [];

    if (this.chevronApp != null) {
      applicationUpdate.chevronApp = this.chevronApp;
      applicationUpdate.newServiceId = this.chevronApp.serviceId;
      if (applicationUpdate.serviceId.length > 0 && (applicationUpdate.newServiceId?.length ?? 0) > 0 && applicationUpdate.serviceId !== applicationUpdate.newServiceId) {
        // add all existing client secret configs to remove list
        applicationUpdate.clientSecretAutoRotationConfigsToRemove = applicationUpdate.clientSecretAutoRotationConfigs;
      }
    }
    else if (applicationUpdate.serviceId?.length > 0 && !Number.isNaN(parseInt(applicationUpdate.serviceId))) {
      let serviceIdOnlyChevronApp = new IdmApplication();
      serviceIdOnlyChevronApp.serviceId = applicationUpdate.serviceId;
      serviceIdOnlyChevronApp = ToStringHelper.overrideToString(serviceIdOnlyChevronApp);
      applicationUpdate.chevronApp = serviceIdOnlyChevronApp;
    }
    else {
      applicationUpdate.chevronApp = null;
    }

    this.applicationUpdatesDataSource.data = [...this.applicationUpdatesDataSource.data, applicationUpdate];
  }

  getPrivilegeAppRoleState(applicationUpdateForm: GraphApplicationUpdateForm, privilegAppRole: IGraphAppExposedPermissions): string {
    let privilegAppRoleState = this.existingConfigState;
    if (applicationUpdateForm.adminAppRolesToRemove?.some(r => r === privilegAppRole.id) ?? false) {
      privilegAppRoleState = this.removedConfigState;
    }
    return privilegAppRoleState
  }

  togglePrivilegeAppRole(applicationUpdateForm: GraphApplicationUpdateForm, privilegAppRole: IGraphAppExposedPermissions) {
    if (applicationUpdateForm.adminAppRolesToRemove?.some(r => r === privilegAppRole.id)) {
      applicationUpdateForm.adminAppRolesToRemove = applicationUpdateForm.adminAppRolesToRemove.filter(r => r !== privilegAppRole.id);
    } else {
      if (!applicationUpdateForm.adminAppRolesToRemove) {
        applicationUpdateForm.adminAppRolesToRemove = [];
      }
      applicationUpdateForm.adminAppRolesToRemove.push(privilegAppRole.id);
    }
  }

  getConfigState(applicationUpdateForm: GraphApplicationUpdateForm, config: IdmClientSecretAutoRotationConfig): string {
    let configState = this.existingConfigState;
    if (applicationUpdateForm.clientSecretAutoRotationConfigsToRemove?.some(r => r.id === config.id) ?? false) {
      configState = this.removedConfigState;
    }
    if (applicationUpdateForm.clientSecretAutoRotationConfigsToAdd?.some(a => a.id === config.id) ?? false) {
      configState = this.addedConfigState;
    }
    return configState;
  }
  addConfigValue(applicationUpdateForm: GraphApplicationUpdateForm, config: IdmClientSecretAutoRotationConfig) {

    if (applicationUpdateForm.serviceId.length > 0 && (applicationUpdateForm.newServiceId?.length ?? 0) > 0 && applicationUpdateForm.serviceId !== applicationUpdateForm.newServiceId &&
      applicationUpdateForm.clientSecretAutoRotationConfigs.some(c => c.id === config.id)) {
      return;
    }

    if (applicationUpdateForm.clientSecretAutoRotationConfigsToRemove) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToRemove = applicationUpdateForm.clientSecretAutoRotationConfigsToRemove.filter(c => c.id !== config.id);
    }

    if (!applicationUpdateForm.clientSecretAutoRotationConfigs) {
      applicationUpdateForm.clientSecretAutoRotationConfigs = [];
    }

    if (!applicationUpdateForm.clientSecretAutoRotationConfigsToAdd) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToAdd = [];
    }

    if (!applicationUpdateForm.clientSecretAutoRotationConfigs.some(c => c.id === config.id) &&
      !applicationUpdateForm.clientSecretAutoRotationConfigsToAdd.some(c => c.id === config.id)) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToAdd.push(config);
    }
  }

  removeConfigValue(applicationUpdateForm: GraphApplicationUpdateForm, config: IdmClientSecretAutoRotationConfig) {
    if (applicationUpdateForm.clientSecretAutoRotationConfigsToAdd) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToAdd = applicationUpdateForm.clientSecretAutoRotationConfigsToAdd.filter(c => c.id !== config.id);
    }

    if (!applicationUpdateForm.clientSecretAutoRotationConfigsToRemove) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToRemove = [];
    }

    // Only add to remove list 
    // if it exists in the current settings and it is not already in the remove list
    if (applicationUpdateForm.clientSecretAutoRotationConfigs.some(c => c.id === config.id)
      && !applicationUpdateForm.clientSecretAutoRotationConfigsToRemove.some(c => c.id === config.id)) {
      applicationUpdateForm.clientSecretAutoRotationConfigsToRemove.push(config);
    }
  }

  getClientSecretConfigsToDisplay(applicationUpdateForm: GraphApplicationUpdateForm): IdmClientSecretAutoRotationConfig[] {
    const configs = [
      ...(applicationUpdateForm.clientSecretAutoRotationConfigs || [])
    ];

    applicationUpdateForm.clientSecretAutoRotationConfigsToRemove?.forEach(config => {
      if (!configs.some(c => c.id === config.id)) {
        configs.push(config);
      }
    });

    applicationUpdateForm.clientSecretAutoRotationConfigsToAdd?.forEach(config => {
      if (!configs.some(c => c.id === config.id)) {
        configs.push(config);
      }
    });

    return configs;
  }

  select(row: GraphApplication) {
    this.selection.toggle(row);

    // If the row is already in the application updates, remove it, otherwise add it
    if (this.applicationUpdatesDataSource.data.find(g => g.id == row.id)) {
      this.deleteRow(row as GraphApplicationUpdate);
    } else {
      this.addapplicationUpdate(row);
    }
  }
  public doFilter = (value: any) => {
    this.applicationsDataSource.filter = value.target.value.trim().toLocaleLowerCase();
  }

  isValid(applicationUpdateForm: GraphApplicationUpdateForm) {
    var isValid = applicationUpdateForm.id && (applicationUpdateForm?.chevronApp || applicationUpdateForm.newServiceId);
    return isValid;
  }
  async onSubmit() {

    // clear error messages
    this.submitErrorMessage.message = '';
    this.submitErrorMessage.errors = [];

    if (this.selection.selected.length > 0 && this.applicationUpdatesDataSource.data.some(g => this.isValid(g))) {
      this.isSubmitting = true;
      let payload = new GraphApplicationsUpdateRequest(this.domain, this.applicationUpdatesDataSource.data.filter(g => this.isValid(g)));

      const observer = {
        next: (x: IGenericApiResponseWithWorkflowRequest<GraphApplication>) => {
          this.submittedRequests = x.requests;
          this.updatedApplications.emit(this.applicationUpdatesDataSource.data.filter(a => a.newServiceId != null).map(a => { a.serviceId = a.newServiceId as string; return a as GraphApplication }));
        },
        error: (err: any) => {
          this.submitErrorMessage.message = err.statusText;
          this.submitErrorMessage.errors = err?.error?.errors ?? [];
          this.isSubmitting = false;
        },
        complete: () => {
          this.isSubmitting = false;
        }
      };

      let updateCall = this.graphApplicationService.UpdateApplications(payload);
      updateCall.subscribe(observer);
    }
  }

  openCreateClientSecretForm(applicationUpdate: GraphApplicationUpdateForm): void {
    const configDialogRef = this.dialog.open(DialogCreateClientSecretAutoRotationConfigFormComponent, {
      disableClose: true,
      autoFocus: true,
      maxWidth: 1000,
      width: '100%',
      maxHeight: 800,
      height: '75vh',
      data: {
        serviceId: applicationUpdate.chevronApp?.serviceId,
        appId: applicationUpdate.appId,
      } as IDialogCreateClientSecretAutoRotationConfigData
    });
    configDialogRef.afterClosed().subscribe(result => {
      if (result) {
        const configs = result as IdmClientSecretAutoRotationConfig[];
        configs.forEach(config => {
          this.addConfigValue(applicationUpdate, config);
        });
      }
    });
  }

  searchForChevronApplication(id: string = ""): void {
    const appDialogRef = this.dialog.open(DialogAppSearchChevronComponent, {
      disableClose: true,
      autoFocus: true,
      maxWidth: 1000,
      width: '100%',
      data: {
        includeEnvironments: false
      } as IDialogAppSearchChevronData
    });

    appDialogRef.afterClosed().subscribe(result => {
      if (result) {
        let chevronApp = result as IIdmApplication;

        // override toString method to display displayName (as form control value will display [object Object] without this)
        chevronApp = ToStringHelper.overrideToString(chevronApp);

        if (id.length > 0) {
          this.applicationUpdatesDataSource.data = [...this.applicationUpdatesDataSource.data.map(g => {
            if (g.id === id) {
              let currentServiceId = g.newServiceId == null || g.newServiceId.length == 0 ? g.serviceId : g.newServiceId;
              let shouldResetClientSecretConfigs = currentServiceId != chevronApp.serviceId;

              g.newServiceId = chevronApp.serviceId;
              g.chevronApp = chevronApp;
              if (shouldResetClientSecretConfigs) {
                g.clientSecretAutoRotationConfigsToAdd = [];
                g.clientSecretAutoRotationConfigsToRemove = [];

                // If there are existing configs and the newServiceId doesn't match the original serviceId, remove them
                if (g.clientSecretAutoRotationConfigs.length > 0 && g.newServiceId != g.serviceId) {
                  g.clientSecretAutoRotationConfigsToRemove = g.clientSecretAutoRotationConfigs;
                }
              }
            }
            return g;
          })];
        }
        else {
          this.chevronApp = chevronApp;

          this.applicationUpdatesDataSource.data = this.applicationUpdatesDataSource.data.map(g => {
            let currentServiceId = g.newServiceId == null || g.newServiceId.length == 0 ? g.serviceId : g.newServiceId;
            let shouldResetClientSecretConfigs = currentServiceId != chevronApp.serviceId;

            g.newServiceId = chevronApp.serviceId;
            g.chevronApp = chevronApp;
            if (shouldResetClientSecretConfigs) {
              g.clientSecretAutoRotationConfigsToAdd = [];
              g.clientSecretAutoRotationConfigsToRemove = [];

              // If there are existing configs and the newServiceId doesn't match the original serviceId, remove them
              if (g.clientSecretAutoRotationConfigs.length > 0 && g.newServiceId != g.serviceId) {
                g.clientSecretAutoRotationConfigsToRemove = g.clientSecretAutoRotationConfigs;
              }
            }
            return g;
          });
        }
      }
    });
  }
}
